import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AttendanceDetail} from './attendance-detail';
import {Student} from '../../../../../../shared-components/student/student.model';
import {StudentService} from '../../../../../../shared-components/student/student.service';

@Component({
    selector: 'app-attendance-details-modal',
    templateUrl: './attendance-details-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./attendance-details-modal.component.css']
})
export class AttendanceDetailsModalComponent implements OnInit {

    attendanceDetails: AttendanceDetail[] = [];
    student: Student;
    // Angular Material Table
    displayedColumns: string[] = ['date', 'code', 'description', 'comment'];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private studentService: StudentService,
        private cdr: ChangeDetectorRef,
        private dialogRef: MatDialogRef<AttendanceDetailsModalComponent>
    ) {
    }

    ngOnInit() {
        this.attendanceDetails = this.data.attendanceDetails;
        this.student = this.studentService.selectedStudent;
        this.updateView();
    }

    updateView() {
        this.cdr.detectChanges();
    }

    closeClick() {
        this.dialogRef.close();
    }

}
